import {Alert} from 'react-bootstrap';

function AlertShow({variant, title, content, show, setShow}) {
    const alertShowStyle = {
        position: 'fixed',
        top: '10px',
        right: '10px',
        zIndex: 9999
    };

    if (show) {
        return (
            <div style={alertShowStyle}>
                <Alert variant={variant} onClose={() => setShow(false)} dismissible>
                    <Alert.Heading>{title}</Alert.Heading>
                    <p>{content}</p>
                </Alert>
            </div>
        );
    }
    return null;
}

export default AlertShow;